import { Controller } from "@hotwired/stimulus"

// Shows the optional "How much does it contain?" row only when the chosen
// selling unit is a CONTAINER (piece/jar/bottle/box/bunch/can/barrel).
// Mirrors Product::CONTAINER_UNITS - keep the two lists in sync.
export default class extends Controller {
  static targets = ["row", "unitSelect", "quantity", "measure"]

  static CONTAINERS = ["piece", "jar", "bottle", "box", "bunch", "can", "barrel", "sack"]

  connect() {
    this.toggle()
  }

  toggle() {
    const container = this.constructor.CONTAINERS.includes(this.unitSelectTarget.value)
    this.rowTarget.classList.toggle("hidden", !container)
    if (!container) {
      // leaving contents behind on a kg/L product would fail validation
      this.quantityTarget.value = ""
      this.measureTarget.value = ""
    }
  }
}
